<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ getPanelTitle() }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-container #fieldComponent></ng-container>
</mat-expansion-panel>
